module.exports = __webpack_public_path__ + "img/1010.c291747c.png";